<template>
  <v-card class="h-100">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <p>Обновлено: {{ updatedAt }}</p>
      <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
      <v-alert v-if="saved" type="success" dense>Версии сохранены</v-alert>
      <v-form ref="form" @submit.prevent="save">
        <v-text-field v-model="latest" label="Последняя версия" :rules="rules"
          :readonly="!canUpdate" :disabled="saving" />
        <v-text-field v-model="minimal" label="Минимальная поддерживаемая версия" :rules="rules"
          :readonly="!canUpdate" :disabled="saving" />
        <v-btn v-if="canUpdate" type="submit" color="primary" :loading="saving" :disabled="!changed">
          Сохранить
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDateUnix } from '@/utils/date';

export default {
  props: {
    title: { type: String, required: true },
    platform: { type: String, required: true },
    version: { type: Object, required: true },
    canUpdate: { type: Boolean, default: false }
  },
  data: () => ({
    latest: '', minimal: '', saving: false, error: '', saved: false,
    rules: [value => !!String(value || '').trim() || 'Укажите версию']
  }),
  computed: {
    updatedAt() {
      return formatDateUnix(this.version.updated_at, 'DD.MM.YYYY HH:mm:ss') || '—';
    },
    changed() {
      return this.latest.trim() !== String(this.version.latest || '') ||
        this.minimal.trim() !== String(this.version.minimal || '');
    }
  },
  watch: {
    version: {
      immediate: true,
      handler(value) {
        this.latest = String(value.latest == null ? '' : value.latest);
        this.minimal = String(value.minimal == null ? '' : value.minimal);
      }
    },
    latest() { this.saved = false; },
    minimal() { this.saved = false; }
  },
  methods: {
    async save() {
      if (!this.canUpdate || this.saving || !this.changed || !this.$refs.form.validate()) return;
      this.saving = true;
      this.error = '';
      this.saved = false;
      try {
        const version = await this.$api.mobileAppVersion.update({
          platform: this.platform, latest: this.latest.trim(), minimal: this.minimal.trim()
        });
        this.$emit('saved', version);
        await this.$nextTick();
        this.saved = true;
      } catch (error) {
        this.error = error.message || 'Не удалось сохранить версии';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
